<template>
  <div>
    <div class="page-title-box">
      <div class="page-title-right">
      </div>
      <h4 class="page-title">Erihindade muutmine</h4>
    </div>

    <div class="card">
      <div class="card-body bg-light">
        <b-form-checkbox v-model="hideServicesWithoutPrice" :value="true" :unchecked-value="false">
          Peida hinnastamata teenused
        </b-form-checkbox>
      </div>

      <div class="card-body">
        <b-form @reset.prevent="resetValues">
          <table class="table table-sm table-vertical-centered table-hover table-sticky">
            <thead class="thead">
              <th class="text-center">Lisa arvele</th>
              <th>Teenus</th>
              <th class="text-right">Üldhind</th>
              <th class="text-right">Erihind</th>
            </thead>
            <tbody>
              <template v-for="(price, index) in data">
                <tr v-show="!hideServicesWithoutPrice || price.genericPrice || price.clientPrice || price.includeInBill">
                  <td width="10%" class="py-1 text-center">
                    <b-form-checkbox v-model="price.includeInBill" :value="true" :unchecked-value="false"></b-form-checkbox>
                  </td>
                  <td>{{price.serviceName}}</td>
                  <td width="15%" class="text-right">
                    <template v-if="price.genericPrice">
                      {{price.genericPrice}} &euro;
                    </template>
                  </td>
                  <td width="20%" class="text-right p-0 px-1">
                      <validated-form-input :name="'service_' + price.serviceId"
                                            v-model="price.clientPrice"
                                            :autofocus="index === 0"
                                            size="sm"
                                            class="mb-0"
                                            :alignRight="true"
                                            validate="decimal|max_value:9999999" :validator="$validator"
                                            :decimal="true"/>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>

          <div class="d-flex justify-content-between">
            <div class="mr-auto">
              <button type="reset" class="btn btn-danger"><i class="mdi mdi-undo-variant mr-1"></i>Taasta</button>
            </div>
            <button type="button" class="btn btn-link mr-2" @click="goBack"><i class="mdi mdi-arrow-left mr-1"></i>Tagasi</button>
            <button type="button" class="btn btn-success" @click="save"><i class="mdi mdi-check mr-1"></i>Salvesta</button>
          </div>

        </b-form>

      </div>
    </div>
  </div>
</template>

<script>
  import ValidatedFormInput from '@/components/ValidatedFormInput'
  import gateway from '@/services/gateway'
  import ClientIdMixin from '../mixins/ClientIdMixin'

  export default {
    components: {ValidatedFormInput},
    mixins: [ClientIdMixin],
    data() {
      return {
        hideServicesWithoutPrice: true,
        data: []
      }
    },
    methods: {
      resetValues() {
        this.data.forEach(price => {
          price.clientPrice = price.originalClientPrice
          price.includeInBill = price.originalIncludeInBill
        })
      },
      goBack() {
        this.$router.back()
      },
      save() {
        this.$validator.validateAll().then(valid => {
          if (!valid) return;
          const prices = this.data
            .filter(p => !!p.clientPrice || p.clientPrice === 0 || p.includeInBill)
            .map(p => ({serviceId: p.serviceId, clientPrice: p.clientPrice, includeInBill: p.includeInBill}))
          gateway.post(`/clients/${this.clientId}/pricelist`, {prices: prices}).then(() => {
            this.$notifications.info('Hinnakiri on salvestatud')
            this.$router.push(`/client`)
          })
        })
      },
      sortByServiceNameAsc(data) {
        data.sort((a, b) => {
          if (a.serviceName < b.serviceName) return -1
          if (a.serviceName === b.serviceName) return 0
          return 1
        })
      },
      load() {
        gateway.get(`/clients/${this.clientId}/pricelist`).then(r => {
          this.data = r.data.map(price => Object.assign({
            clientPrice: null,
            includeInBill: false,
            originalClientPrice: price.clientPrice,
            originalIncludeInBill: price.includeInBill
          }, price))
          this.sortByServiceNameAsc(this.data)
        })
      },
    }
  }
</script>
